import AlternativesQueries from '@Alternatives/Alternatives/Domain/queries-vue-component';
import { AlternativeReadModel, AlternativesReadModel } from '@Alternatives/Alternatives/Domain/readmodels';
import { AlternativesViewDeleterDialogViewModel } from '@Alternatives/AlternativesViews/Components/AlternativesViewDeleterDialog';
import AlternativesViewDeleterDialog from '@Alternatives/AlternativesViews/Components/AlternativesViewDeleterDialog.vue';
import { AlternativesViewDependenciesDialogViewModel } from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesDialog';
import AlternativesViewDependenciesDialog from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesDialog.vue';
import AttributeFilter from '@Alternatives/AlternativesViews/Components/Filters/AttributeFilter.vue';
import ListFilter from '@Alternatives/AlternativesViews/Components/Filters/ListFilter.vue';
import StatusFilter from '@Alternatives/AlternativesViews/Components/Filters/StatusFilter.vue';
import { CreateDynamicViewCommandV1, CreateStaticViewCommandV1, DeleteAlternativesViewCommandV1, UpdateDynamicViewCommandV1, UpdateStaticViewCommandV1 } from '@Alternatives/AlternativesViews/Domain/commands-core';
import AlternativesViewsCommands from '@Alternatives/AlternativesViews/Domain/commands-vue-component';
import { AlternativesViewType } from '@Alternatives/AlternativesViews/Domain/model';
import AlternativesViewsQueries from '@Alternatives/AlternativesViews/Domain/queries-vue-component';
import { AlternativeFilterReadModel, AlternativesViewReadModel, CompoundFilterReadModel, ListDependenciesReadModel, ListsPageReadModel } from '@Alternatives/AlternativesViews/Domain/readmodels';
import { AlternativesViewsUtils } from '@Alternatives/AlternativesViews/utils';
import { isNullOrWhitespace, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { guid } from '@common/Guid';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: { PortfolioOrDecisionNavigation, AttributeFilter, StatusFilter, ListFilter, AlternativesViewDependenciesDialog, AlternativesViewDeleterDialog, AlternativesViewsCommands }
})
export default class ListsPage extends mixins(AlternativesViewsQueries, AlternativesQueries, AlternativesViewsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

    viewDefId: string = null;

    rm: ListsPageReadModel = null;
    listSearchPhrase: string = null;
    alternativesSearchPhrase: string = null;
    IsEdited: boolean = false;
    EditedIncluded: string[] = [];

    alternativesViewDeleterDialog: AlternativesViewDeleterDialogViewModel = new AlternativesViewDeleterDialogViewModel();
    alternativesViewDependenciesDialog: AlternativesViewDependenciesDialogViewModel = new AlternativesViewDependenciesDialogViewModel();
    get filter(): CompoundFilterReadModel { return this.SelectedView?.AdvancedFilter; }

    get SelectedView(): AlternativesViewReadModel
    {
        if (this.viewDefId)
        {
            return this.rm?.Views.find(a => a.Id === this.viewDefId);
        }

        return null;
    }

    get listsView(): AlternativesViewReadModel[]
    {
        let view = new Array(...this.rm.Views ?? []);

        if (this.listSearchPhrase)
        {
            const phrase = this.listSearchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().trim().indexOf(phrase) > -1);
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
    }

    get alternativesView(): AlternativeReadModel[] 
    {
        let view = new Array(...this.rm.Alternatives ?? []);

        if (this.SelectedView.IsStatic === false || (this.SelectedView.IsStatic === true && this.IsEdited === false))
        {
            view = view.filter(a => this.SelectedView.Included?.some(b => b === a.AlternativeId.toString()))
        }

        if (this.alternativesSearchPhrase)
        {
            const phrase = this.alternativesSearchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().trim().indexOf(phrase) > -1);
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
    }


    generateName()
    {
        let index = 1;

        while (this.rm.Views.filter(a => a.Name == `View ${index}`).length > 0)
        {
            index++;
        }

        return `View ${index}`;
    }


    createStaticList()
    {
        const viewDef = new AlternativesViewReadModel();
        viewDef.Id = guid();
        viewDef.Name = this.generateName();
        viewDef.AlternativesListId = this.rm.AlternativesListId;
        viewDef.Type = AlternativesViewType.Static;
        viewDef.AdvancedFilter = null;
        viewDef.Included = [];

        viewDef.IsValid = true;
        viewDef.IsStatic = true;
        viewDef.IsPersisted = false;

        this.rm.Views.push(viewDef);
        this.viewDefId = viewDef.Id;
        this.IsEdited = true;
    }

    createActiveList()
    {
        const viewDef = new AlternativesViewReadModel();
        viewDef.Id = guid();
        viewDef.Name = this.generateName();
        viewDef.AlternativesListId = this.rm.AlternativesListId;
        viewDef.Type = AlternativesViewType.Advanced;
        viewDef.AdvancedFilter = AlternativesViewsUtils.BuildCompoundFilter("And");
        viewDef.Included = [];

        viewDef.IsValid = true;
        viewDef.IsStatic = false;
        viewDef.IsPersisted = false;

        this.rm.Views.push(viewDef);
        this.viewDefId = viewDef.Id;
        this.IsEdited = true;
    }

    cloneList()
    {
        const source = this.SelectedView;

        const clone = JSON.parse(JSON.stringify(source)) as AlternativesViewReadModel;
        clone.Id = guid();
        clone.Name = source.Name + " (1)";
        clone.IsPersisted = false;

        this.rm.Views.push(clone);
        this.SelectView(clone.Id);
        this.IsEdited = true;
    }

    cloneAsStaticList()
    {
        const source = this.SelectedView;

        const clone = JSON.parse(JSON.stringify(source)) as AlternativesViewReadModel;
        clone.Id = guid();
        clone.Name = source.Name + " static";
        clone.Type = AlternativesViewType.Static;
        clone.IsStatic = true;
        clone.IsPersisted = false;

        this.rm.Views.push(clone);
        this.SelectView(clone.Id);
        this.IsEdited = true;
    }

    startListEditing()
    {
        this.EditedIncluded = [...this.SelectedView.Included];
        this.IsEdited = true;
    }

    cancelListEditing()
    {
        this.EditedIncluded = [...this.SelectedView.Included];
        this.IsEdited = false;

        if (!this.SelectedView.IsPersisted)
        {
            this.rm.Views.remove(this.SelectedView);

            if (this.rm.Views.length > 0)
            {
                this.SelectView(this.rm.Views[0].Id);
            }
        }
    }


    showListDeleter()
    {
        this.alternativesViewDeleterDialog.show(this.SelectedView.Id, this.SelectedView.Name);
        this.runListDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, this.SelectedView.Id);
    }

    showListDependenciesViewer()
    {
        this.alternativesViewDependenciesDialog.show(this.SelectedView.Id, this.SelectedView.Name);
        this.runListDependenciesQueryV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, this.SelectedView.Id);
    }


    //Dynamic List filters
    addFilter(type: string) 
    {
        const f = AlternativesViewsUtils.BuildFilterReadModel(type);
        f.IsEdited = true;
        this.filter.Filters.push(f);
    }

    deleteFilter(rm: AlternativeFilterReadModel)
    {
        this.filter.Filters.remove(rm);
    }


    //Static List include / exclude
    IsEditedIncluded(alternativeId: number): boolean { return this.EditedIncluded.indexOf(alternativeId.toString()) > -1; }

    Include(alternativeId: number)
    {
        this.EditedIncluded.push(alternativeId.toString());
    }

    Exclude(alternativeId: number)
    {
        this.EditedIncluded.remove(alternativeId.toString());
    }


    filterAlternatives()
    {
        if (this.SelectedView.IsStatic === false)
        {
            this.runAlternativesByViewDefIdQueryV1(this.workspaceId, this.projectId, this.SelectedView.Id);
        }
    }


    SelectView(id: string)
    {
        this.viewDefId = id;

        if (this.SelectedView.IsStatic)
        {
            this.EditedIncluded = [...this.SelectedView.Included];
        }
        else 
        {
            this.filterAlternatives();
        }
    }

    SaveCommand()
    {
        if (isNullOrWhitespace(this.SelectedView.Name))
        {
            alert("List name is required");
        }
        else
        {
            if (this.SelectedView.IsStatic)
            {
                this.SelectedView.Included = [...this.EditedIncluded];
                const alternativeIds = this.SelectedView.Included.map(a => Number(a));

                if (this.SelectedView.IsPersisted)
                {
                    this.invokeUpdateStaticViewCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, this.SelectedView.Id, this.SelectedView.Name, alternativeIds);
                }
                else
                {
                    this.invokeCreateStaticViewCommandV1(this.workspaceId, this.SelectedView.Id, this.rm.AlternativesListId, alternativeIds, this.SelectedView.Name);
                }

                this.IsEdited = false;
            }
            else
            {
                const f = { Type: this.filter.Type, Data: this.filter.Filters.map(a => ({ Type: a.Type, Data: a.Data })) };

                if (this.SelectedView.IsPersisted)
                {
                    this.invokeUpdateDynamicViewCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, this.SelectedView.Id, this.SelectedView.Name, JSON.stringify(f));
                }
                else
                {
                    this.invokeCreateDynamicViewCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, this.SelectedView.Id, this.SelectedView.Name, JSON.stringify(f));
                }

                this.IsEdited = false;
            }
        }
    }

    handleDeleteAlternativesViewCommand(listId: string)
    {
        this.invokeDeleteAlternativesViewCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, listId)
    }


    mounted()
    {
        document.title = "Lists | TransparentChoice";
        this.viewDefId = this.$route.params.viewDefId ?? null;
        this.runListsPageQueryV1(this.workspaceId, this.projectId, this.viewDefId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ListsPageReadModel")
        {
            this.rm = model as ListsPageReadModel;

            if (this.rm.Views.length > 0)
            {
                this.SelectView(this.rm.Views[0].Id);
            }
        }
        else if (modelName == "AlternativesReadModel")
        {
            const filtered = model as AlternativesReadModel;
            this.SelectedView.Included = filtered.Alternatives.map(a => a.AlternativeId.toString());
        }
        else if (modelName == "ListDependenciesReadModel")
        {
            const rm = model as ListDependenciesReadModel;

            this.alternativesViewDependenciesDialog.setData(rm);
            this.alternativesViewDeleterDialog.setData(rm);
        }
    }

    onCommandSucceed(cmd: any, correlationId: string, result: any)
    {
        if (CreateStaticViewCommandV1.matchType(cmd))
        {
            const list = this.rm.Views.find(a => a.Id === correlationId);
            list.IsPersisted = true;
        }
        else if (UpdateStaticViewCommandV1.matchType(cmd))
        {
            const list = this.rm.Views.find(a => a.Id === correlationId);
            list.IsPersisted = true;
        }
        else if (CreateDynamicViewCommandV1.matchType(cmd))
        {
            const list = this.rm.Views.find(a => a.Id === correlationId);
            list.IsPersisted = true;
            this.filterAlternatives();
        }
        else if (UpdateDynamicViewCommandV1.matchType(cmd))
        {
            const list = this.rm.Views.find(a => a.Id === correlationId);
            list.IsPersisted = true;
            this.filterAlternatives();
        }
        else if (DeleteAlternativesViewCommandV1.matchType(cmd))
        {
            const removed = this.rm.Views.find(a => a.Id === correlationId);
            this.rm.Views.remove(removed);

            if (this.rm.Views.length > 0)
            {
                this.SelectView(this.rm.Views[0].Id);
            }

            this.alternativesViewDeleterDialog.close();
        }
    }
}